import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { sklepyMarketplace } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/sklepy-marketplace";

export const Route = createFileRoute("/integracje/sklepy-marketplace")({
  head: () =>
    buildSeoMeta({
      title: "Integracja sklepu z Allegro, Amazon, eBay — sprzedaż wielokanałowa | SyncTech",
      description:
        "Integracje sklepów internetowych (Shopify, Shoper, ShopGold, PrestaShop) z marketplace'ami: Allegro, Amazon, eBay, Empik, Kaufland. Jeden magazyn, jedna prawda, zero oversellingu.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={sklepyMarketplace} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
